import Skeleton from "@/shared/ui/Skeleton";

export default function WorkerDetailSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <div className="p-7 radius-3xl surface-base-fill flex flex-col gap-4">
        <div className="flex items-center gap-4">
          <Skeleton circle width={64} height={64} />
          <div className="flex flex-col gap-2">
            <Skeleton width={200} height={24} borderRadius={8} />
            <Skeleton width={140} height={16} borderRadius={6} />
          </div>
        </div>
        <div className="flex gap-6">
          <Skeleton width={100} height={32} borderRadius={6} />
          <Skeleton width={100} height={32} borderRadius={6} />
          <Skeleton width={100} height={32} borderRadius={6} />
        </div>
      </div>

      <div className="p-7 radius-3xl surface-base-fill flex flex-col gap-4">
        <Skeleton width={180} height={20} borderRadius={6} />
        {Array.from({ length: 6 }).map((_, idx) => (
          <div key={idx} className="flex items-center justify-between py-3">
            <Skeleton width={120} height={16} borderRadius={4} />
            <Skeleton width={160} height={16} borderRadius={4} />
          </div>
        ))}
      </div>

      <div className="p-7 radius-3xl surface-base-fill flex flex-col gap-4">
        <Skeleton width={160} height={20} borderRadius={6} />
        {Array.from({ length: 3 }).map((_, idx) => (
          <div key={idx} className="flex items-center justify-between py-3">
            <Skeleton width={120} height={16} borderRadius={4} />
            <Skeleton width={160} height={16} borderRadius={4} />
          </div>
        ))}
      </div>
    </div>
  );
}
